require('animation.gsap');
const TimelineMax = require('TimelineMax');
const TweenLite = require('TweenLite');
require('gsap/ScrollToPlugin');
const Promise = require("bluebird");
import $ from 'jquery';

import pageActueelThema from "../pages/page-actueel-thema.vue";
import pageWatIs from "../pages/page-wat-is-1.vue";
import pageSplash from "../pages/page-splash.vue";
import pageTenEerste from "../pages/page-ten-eerste.vue";
import pageWilCombineren from "../pages/page-wil-combineren.vue";
import pageDagenKiezen from "../pages/page-dagen-kiezen.vue";
import pageLesgeven from "../pages/page-lesgeven.vue";
import pageLesbevoegdheid from "../pages/page-lesbevoegdheid.vue";
import pageContact from "../pages/page-contact.vue";
import pageProfielOverzicht from "../pages/page-profiel-overzicht.vue";
import pageIntro from "../pages/page-intro.vue";
import pageBekenden from "../pages/page-bekenden.vue";
import pageCombinatie from "../pages/page-combinatie.vue";
import pageSoorten from "../pages/page-soorten.vue";
import pageNiveau from "../pages/page-niveau.vue";
import pageQuotes from "../pages/page-quotes.vue";
import pageSlot from "../pages/page-slot.vue";
import profile from "../profile/profile.vue";
import exampleProfiles from "../example-profiles/example-profiles.vue";
import appModel from "./app-model";

export default {
    name: 'application',
    data() {
        return appModel
    },
    mounted() {
        console.log('application mounted');
    },
    computed: {
        showTenEerste() {
            return true;
        },
        showIntro() {
            return this.showUitleg;
        },
        showBekenden() {
            return this.showUitleg;
        },
        showSoorten() {
            return true;
        },
        showWilCombineren() {
            return this.userProfile.isATeacher();
        },
        showNiveau() {
            return this.userProfile.isNotATeacher();
        },
        showDagenKiezen() {
            return true;
        },
        showLesgeven() {
            return this.userProfile.isNotATeacher() && this.userProfile.onderwijsniveau === 'voortgezet onderwijs';
        },
        showLesbevoegdheid() {
            return this.userProfile.isNotATeacher();
        },
        showQuotes() {
            return true;
        },
        showContact() {
            return true;
        },
        showSlot() {
            return this.submitted;
        },
        showProfielOverzicht() {
            return this.userProfile.opMaat && this.userReady;
        }
    },
    methods: {
        focusinHandler(event) {
          console.log('focusin:' + event.target.classList.value);
        },
        uitlegHandler() {
            this.showUitleg = true;
            this.goTo('#page-intro');
        },
        profileUpdateHandler(hashes) {
            this.userReady = false;
            const hashAr = Array.isArray(hashes) ? hashes : [hashes];

            hashAr.forEach( (hash, i) => {
                this.userProfile[hash.key] = hash.value;

                /* For now take the first property as 'main' property */
                if (i === 0) {
                    this.mainProfileChange = hash.key;
                }

                /* Some business logic */
                if (hash.key === 'baan1') {
                    if (!hash.value.isTeacher) {
                        this.userProfile.baan2 = {category: null, label: "Leraar", isTeacher: true, profileText: "met een baan als leraar"};
                    } else if (hash.value.isTeacher === true) {
                        this.userProfile.baan2 = null;
                    }
                }

                if (hash.key === 'bevoegdheid' && !hash.value) {
                    this.userProfile.bevoegdheidIn = null;
                }

                if (hash.key !== 'hasSubmitted') {
                    this.userProfile.hasSubmitted = false;
                }

                if (hash.key === 'onderwijsniveau') {
                    this.userProfile.vak2 = null;
                }
            })
        },
        pageSplashNextHandler() {
            this.goTo('#page-soorten');
        },
        pageIntroNextHandler() {
            this.goTo('#page-wat-is');
        },
        pageWatIsNextHandler() {
            this.goTo('#page-actueel-thema');
        },
        pageActueelThemaHandler() {
            this.goTo('#page-bekenden');
        },
        pageBekendenNextHandler() {
            this.goTo('#page-soorten');
        },
        pageSoortenNextHandler() {
            this.goTo('#page-ten-eerste');
        },
        pageTenEersteNextHandler() {
            const nextPage = this.userProfile.baan1.isTeacher ? '#page-wil-combineren' : '#page-niveau' ;
            this.goTo(nextPage);
        },
        pageWilCombinerenNextHandler() {
            // const nextPage = this.userProfile.baan1 === 'Leraar' ? '#page-dagen-kiezen' : '#page-niveau' ;
            const nextPage = '#page-dagen-kiezen';
            this.goTo(nextPage);
        },
        pageNiveauNextHandler() {
            if (this.userProfile.onderwijsniveau === 'voortgezet onderwijs') {
                this.goTo('#page-lesgeven')
            } else {
                this.goTo('#page-lesbevoegdheid');
            }
        },
        pageDagenKiezenNextHandler() {
            this.goTo('#page-combinatie');
        },
        pageContactNextHandler() {
          if (this.userProfile.opMaat) {
              this.userReady = true;
              this.goTo('#page-profiel-overzicht')
          }  else {
              this.goTo('#page-slot')
          }
        },
        submitRegistration() {
            this.submitPending = true;
            this.userProfile.textProfile = $('.profile__result').html();
            const url = window.location.hostname.search('localhost') !== -1 ?
              'http://dev.local/hybridedocent/api/mail/index.php' :
              'https://app.hybridedocent.nl/api/mail/index.php';
            $.post(url, JSON.stringify(this.userProfile))
              .done(() => {
                this.submitted = true;
                this.submitPending = false;
                this.goTo('#page-slot');
              })
              .fail(() => {
                console.log('failed');
                this.submitPending = false;
              });
        },
        goTo(selector) {
            this.$nextTick(() => {
                TweenLite.to(window, 1, {scrollTo: {y: selector, offsetY: -2, autoKill:false}});
            });
        }
    },
    components: {
        pageActueelThema,
        pageWatIs,
        pageSplash,
        pageIntro,
        pageBekenden,
        pageTenEerste,
        pageSoorten,
        pageCombinatie,
        pageWilCombineren,
        pageNiveau,
        pageDagenKiezen,
        pageLesgeven,
        pageLesbevoegdheid,
        pageQuotes,
        pageContact,
        pageProfielOverzicht,
        pageSlot,
        profile,
        exampleProfiles
    }
}


// WEBPACK FOOTER //
// ./src/components/application/application.js